import React, { FC } from "react";
import { dataService2 } from "../../utils/helpers/view/detailsHelper";
import { createGlobalStyle } from "styled-components";
import RainIcon from 'saur_ui_library/src/Icons/RainIcon';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import ModalFlexible from 'saur_ui_library/src/Organisms/ModalFlexible/ModalFlexible';

type ErrorMessageProps = {
  IsVisible: any;
};

const ErrorMessage: FC<ErrorMessageProps> = (props) => {
  const [modalVisible, setModalVisible] = React.useState(props.IsVisible);
  const popupContent = () => (
    <Container className='contentContainer' style={{ width: 550, height: 100 }}>
      <RainIcon />
      <Word
        className='errorMessage'
        variant='p'
        textStyle='normalReg'
        value='Nous ne pouvons pas afficher la donnée car elle est inexistante '
      />
    </Container>
  );
  
  return (
    <Container className="errorContainer">
      <Styles />
      <ModalFlexible
    className="error-modal"
    showHeader
    title="Donnée inexistante"
    toggleModal={() => {setModalVisible(!props.IsVisible); 
      dataService2.setError(false);
    }}
    visible={modalVisible}
    desktopContent={popupContent}
  
  />
    </Container>
  );
};
const Styles = createGlobalStyle`
.sds-reset-style{
  .pi{
    font-family: 'primeicons';
  }
.errorContainer{
  z-index:200;
  .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position {
    bottom: 65%;
  }
  .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position .modal-flex-desktop-content .modal-flex-desktop-header {
    align-items: flex-end !important;
    flex-direction: column !important;
    padding: 0px !important;
  }
}
.contentContainer{
  margin-left: auto;
  margin-right: auto;  
}
.errorMessage{
  margin-left: auto;
  margin-right: auto; 
}
}
`;
export default ErrorMessage;
